import type { ActualSourceKind, TimelineStop } from '../trip-timeline.api';

const MILESTONE_LABELS: Record<string, string> = {
  arrived: 'Arrived',
  loaded: 'Loaded',
  unloaded: 'Offloaded',
  departed: 'Departed',
  empty_returned: 'Empty returned',
  fuel_stop: 'Fuel stop',
  exception: 'Exception',
  pod_captured: 'Proof of delivery',
  stop_reached: 'Stop reached',
  geofence_entered: 'Entered a place not on the plan',
  geofence_exited: 'Left a place not on the plan',
};

export const SOURCE_LABELS: Record<ActualSourceKind, string> = { geofence: 'Geofence', driver_tap: 'Driver tap', office: 'Office' };

const STOP_KIND_LABELS: Record<TimelineStop['kind'], string> = { pickup: 'Pickup', drop: 'Drop', empty_return_depot: 'Empty-return depot', yard: 'Yard' };

export function milestoneLabel(milestone: string): string {
  return MILESTONE_LABELS[milestone] ?? milestone.replaceAll('_', ' ');
}

export function stopHeading(stop: Pick<TimelineStop, 'position' | 'kind' | 'name'>): string {
  return `${stop.position}. ${STOP_KIND_LABELS[stop.kind]}: ${stop.name}`;
}

/** What the gap from arriving to loading or offloading is, said as it is: the log has no "loading started", so the wait is inside it. */
export function sinceArrivalLabel(milestone: string): string {
  return milestone === 'unloaded' ? 'arrived to offloaded, waiting plus offloading' : 'arrived to loaded, waiting plus loading';
}
